"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Settings_module_css_1 = __importDefault(require("./styles/Settings.module.css"));
const SubNav_1 = __importDefault(require("./SubNav"));
const react_router_dom_1 = require("react-router-dom");
const localConstants_1 = require("src/stores/applicationStore/app/localConstants");
const Settings = () => {
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: Settings_module_css_1.default.container }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: Settings_module_css_1.default.navContainer }, { children: (0, jsx_runtime_1.jsx)(SubNav_1.default, { navItems: localConstants_1.SETTINGS_SUB_NAVIGATIONS }) })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: Settings_module_css_1.default.contentContainer }, { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Outlet, {}) }))] })));
};
exports.default = Settings;
